import './editable-string-list.scss'

import { faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { defineComponent } from 'vue';

import { TranslatedString, createTranslatedString, getTranslatedString } from '@skinsoft/types';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';

declare const config
const FALLBACK_LOCALE = config.fallback_locale

export const EditableTranslatedStringList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: ['values', 'editMode', 'dataCy'],
    template: require('./editable-string-list.html'),
    data() {
        return {
            modelList: [] as TranslatedString[],
            locale: FALLBACK_LOCALE,
            // Icons
            trashIcon: faTrash,
            addIcon: faPlusCircle,
        }
    },
    methods: {
        getStringValue(value: any) {
            return getTranslatedString(value, this.getAppLocale());
        },
        getVModel(value: any) {
            return value.translatedString[this.getAppLocale()]
        },
        onDeleteClick(index: number) {
            this.values.splice(index, 1)
        },
        onAddClick() {
            this.modelList.push(createTranslatedString(this.getAppLocale(), ""));
        },
    },
    watch: {
        values: {
            handler() {
                this.modelList = this.values;
                if (!this.modelList[0] || !this.modelList[0].translatedString) {
                    this.modelList[0] = createTranslatedString(this.getAppLocale(), "")
                }
                this.locale = this.getAppLocale()
            },
            immediate: true,
        },
    },
})
